export default __webpack_public_path__ + "static/media/MainPod_Image@3x.58847798.png";